import React from "react";
import Agri_transition from "../../assets/images/Agri_transition.png";
import agglogo from "../../assets/logos/portfolio/Agg_logo.png";
import { ArrowRight } from "@mui/icons-material";

const AggenomeSection = () => {
  return (
    <section
      className="observeClass aggenome min-h-screen bg-white"
      id="aggenome"
    >
      <div className="topSection min-h-[80vh] flex flex-wrap">
        <div className="left w-full md:w-6/12 flex justify-center items-center pt-32 md:pt-0">
          <div className="contentWrapper w-full pl-4 md:pl-7 lg:pl-32 text-white">
            <div className="logo mb-16">
              <img src={agglogo} alt="" />
            </div>
            <div className="content mb-8">
              <p className=" text-base font-medium w-8/12">
                Developed rice seed varieties that provide 25% more yield & are
                entering regulatory approval process in 2021
              </p>
            </div>
            <div className=" company mb-10">
              <h1 className=" text-3xl font-semibold mb-2">AgriGenome</h1>
              <p className=" text-sm">
                India’s leading agriculture genomics company
              </p>
            </div>
            <div className="linkButton mb-4 md:mb-0">
              <a
                href="https://www.aggenome.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className=" px-3 py-2 border rounded-full">
                  www.aggenome.com
                </button>
              </a>
            </div>
          </div>
        </div>
        <div className="right w-full md:w-6/12 flex justify-center items-center">
          <div className="contentWrapper w-full pl-3 md:pl-5 lg:pl-10 text-white pt-16">
            <div className="vision mb-2">
              <h1 className=" text-lg">Vision:</h1>
              <ul>
                <li className=" text-sm">
                  <ArrowRight fontSize="small" />
                  Apply genomics to develop better crops
                </li>
              </ul>
            </div>
            <div className="vision mb-2">
              <h1 className=" text-lg">Strategy:</h1>
              <ul>
                <li className=" text-sm">
                  <ArrowRight fontSize="small" />
                  Provide DNA sequencing and analytics services to government
                  labsand seed companies in India.
                </li>
                <li className=" text-sm mb-3">
                  <ArrowRight fontSize="small" />
                  Develop proprietary product lines, starting with rice
                  varieties
                </li>
                <li className=" text-sm">
                  <ArrowRight fontSize="small" />
                  Offers genotyping, sanger and NGS sequencing services
                </li>
                <li className=" text-sm">
                  <ArrowRight fontSize="small" />
                  Labs in Kochi & Hyderabad
                </li>
                <li className=" text-sm">
                  <ArrowRight fontSize="small" />
                  Green house and tissue culture facilities in Kochi
                </li>
              </ul>
            </div>

            <div className="portfolio-sprite flex">
              <div className="img flex items-center flex-col">
                <div className="founded mb-2"></div>
                <div className="text text-center text-sm">
                  <span className=" font-medium">Founded</span> <br />
                  2016
                </div>
              </div>
              <div className="img flex items-center flex-col">
                <div className="location mb-2"></div>
                <div className="text text-center text-sm">
                  <span className=" font-medium">Location</span> <br />
                  Kochi, India <br /> Hyderabad, India
                </div>
              </div>
              <div className="img flex items-center flex-col">
                <div className="people mb-2"></div>
                <div className="text text-center text-sm">
                  <span className=" font-medium">People</span> <br />
                  100
                </div>
              </div>
              <div className="img flex items-center flex-col">
                <div className="ledby mb-2"></div>
                <div className="text text-center text-sm">
                  <span className=" font-medium">Led By</span> <br />
                  Dr. George Thomas <br /> Dr. VB Reddy
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bottomSection min-h-[20vh] flex justify-center bg-[#0e914d]">
        <div className="years px-4 md:px-7 lg:px-32 py-5 overflow-x-auto">
          <img src={Agri_transition} alt="" />
        </div>
      </div>
    </section>
  );
};

export default AggenomeSection;
